import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class SearchEngineOptimisationSEO extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="Search Engine Optimisation | SEO"
					title={"search engine optimisation seo"}
					image={require('./image-6.jpg')}
				/>
				<div className="entry-content page-blog">


				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                                Search Engine Optimisation SEO
                            			</div>
                       			 </h2>
                    		</div>

					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							

								<p>A website is like a car: they are both complex machines with lots of interrelating parts.  The same as a car, a website must be serviced to ensure the parts interact correctly.  One aspect of this servicing is SEO.  </p>
<img src={require('./Moshi-SEO-Report.png')} style={{padding: 30}} height="375" width="350" alt="SEO Website Traffic Report" className="align-right" align="right" />
								
<p><b>Search engines</b> (like Google) need a lot of information to understand whether a website is relevant to people searching for it.  If the information is not clear, the website sinks further down search listings or does not show at all.  Moshi has specialists to ensure Google clearly understands what your business does and where you are located.</p>
<p>Your <b>Google Business Listing</b> needs to be correctly set up for people to find it on Google Maps and leave you good reviews, also helping your SEO. </p>
<p>In the long term, customers making <b>return visits</b> to your website is the most important SEO factor.  Writing <b>regular</b> news or information blogs that bring people back to your website is an important SEO strategy.  Moshi’s <a href="/whatwedo/website-and-newsletter-content-writing">copywriters</a> can help you keep website content fresh and engaging.</p>
<p>Digital marketing strategies such as <a href="/whatwedo/google-ads">Google Display banner adverts</a> and <a href="/whatwedo/social-media-marketing">Social Media Marketing</a> also help drive interested traffic to your website.</p>
<p>Our SEO service includes access to a comprehensive website traffic report that details not only who visits your website, but how successful your website is in gaining enquiries.</p>


<p>
</p> <p>
</p>
<br></br>
<hr></hr>
<h2>Related Services</h2>
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-development">Website Development</a> 
<a class="btn" href="https://www.moshi.com.au/whatwedo/google-ads">Google Ads</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/photography-and-video-shoots">Photography and Video Shoots</a>		
<a class="btn" href="https://www.moshi.com.au/whatwedo/email-newsletter-management">Email Newsletter Management</a>		
<a class="btn" href="https://www.moshi.com.au/whatwedo/social-media-management">Social Media Management</a>	
<hr></hr>
<br></br>
						
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>
<h3>SEO is a long game and Moshi can help you set up strategies to make sure your website stays relevant and can be found by your customers.</h3>
					</div>
				</div>

			</div>
		);
	}
}

export default SearchEngineOptimisationSEO;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/SearchEngineOptimisationSEO.js